import * as React from "react";
import Checkbox from "./checkbox";
export default class SearchField extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement("div", { className: "search-field", onClick: this.props.onClick },
            React.createElement(Checkbox, { selected: this.props.selected, onClick: this.props.onClick }),
            React.createElement("div", { className: "label" }, this.props.label.trim() || "N/A")));
    }
}
;
//# sourceMappingURL=search-field.js.map